import './main.css';
import 'react-calendar/dist/Calendar.css';
import Layout from 'utils/layout';
import Video from 'utils/video';
// import Swiper bundle with all modules installed
// TODO: optimize so only required modules are imported.
// importing everything now so dev has no roadblocks
import Swiper from 'swiper/bundle';

(() => {
  const uniq = (value, index, self) => self.indexOf(value) === index;
  const sections = document.querySelectorAll('[data-section]');
  const sectionNames = [...sections]
    .map((section) => section.dataset.section)
    .filter(uniq);
  const layout = new Layout();

  sectionNames.forEach((name) => {
    import(/* webpackChunkName: "[index]" */ `./${name}/index.js`)
      .then((m) => {
        const module = m.default;
        const modules = [...sections].filter(
          (section) => section.dataset.section === name,
        );
        modules.forEach((element) => {
          try {
            const dataEl = element.querySelector('[data-section-data]');
            const data = dataEl ? JSON.parse(dataEl.textContent) : {};
            const videoEls = element.querySelectorAll('[data-component="video"]');
            const videos =
              videoEls &&
              [...videoEls].map(
                (videoEl) => new Video({ element, video: videoEl, layout }),
              );
            module(element, { ...data, layout, videos });
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error, 'with parsing module:', element.querySelector('[data-section-data]'))
          }
        });
      })
      // eslint-disable-next-line no-console
      .catch(console.error);
  });

  // expose Swiper to global scope for third parties
  window.Swiper = Swiper;
})();
